"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikSlideSwitch = void 0;
var react_1 = __importDefault(require("react"));
var morse_react_1 = require("morse-react");
var formik_1 = require("formik");
var FormikSlideSwitch = function (props) {
    var context = formik_1.useFormikContext();
    var field = context.getFieldProps(props.name);
    return (react_1.default.createElement(formik_1.FastField, { name: props.name }, function (_a) {
        var form = _a.form, field = _a.field;
        return (react_1.default.createElement(morse_react_1.Switch, __assign({ slide: true, id: props.name }, props, { checked: !!field.value, onChange: function (e) {
                var _a;
                context.setFieldValue(props.name, e.target.checked);
                (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e.target.checked);
            } })));
    }));
};
exports.FormikSlideSwitch = FormikSlideSwitch;
//# sourceMappingURL=FormikSlideSwitch.js.map